export const FETCH_UI_CONFIG = "FETCH_UI_CONFIG";
export const FETCH_UI_CONFIG_FAILURE =
  "FETCH_UI_CONFIG_FAILURE";
export const FETCH_UI_CONFIG_SUCCESS =
  "FETCH_UI_CONFIG_SUCCESS";
export const RESET_UI_CONFIG = "RESET_UI_CONFIG";